module.exports = __webpack_public_path__ + "img/stock1.7b59d123.png";